export default __webpack_public_path__ + "static/media/2472.632b3c47.png";